import { createSlice } from "@reduxjs/toolkit";
import { SaveNatureApi } from "../action/SaveNatureAction";

const SaveNatureReducer = createSlice({
	name: "SaveNatureReducer",
	initialState: {
		SavenatureData: [],
		loading: false,
		errors: {},
	},
	reducers: {},
	extraReducers: {
		[SaveNatureApi.pending]: (state) => {
			state.loading = true;
		},
		[SaveNatureApi.fulfilled]: (state, action) => {
			state.loading = false;
			state.SavenatureData = action.payload.response;
		},
		[SaveNatureApi.rejected]: (state, action) => {
			state.loading = false;
			state.errors = action.payload;
		},
	},
});

export default SaveNatureReducer.reducer;
